__turbopack_context__.v({
  "text": "U7thoa_text",
  "toggle": "U7thoa_toggle",
});
